export default __webpack_public_path__ + "static/media/blue-hdb-block.b14c1e9c.svg";